import {
  SET_DATAGUARD_HEADER_DATA,
  SET_DATAGUARD_HEATMAP_DATA,
  SET_DATAGUARD_ROLES_DATA,
  SET_DATAGUARD_BEHAVIOR_DATA,
  SET_DATAGUARD_FROM_TIME_STAMP,
  SET_DATAGUARD_TO_TIME_STAMP,
  SET_LOCATION_SUMMARY,
  SET_DATAGUARD_INCOGNITO,
  SET_KEY_DOC_OWNER_DATA,
  SET_NOTIFICATION_UPDATE_STATUS,
  SET_REVOKE_ACCESS_UPDATE_STATUS,
} from "../Utility/DataguardConstant";
import {
  SET_POPUP_DATA,
  SET_POPUP_OPEN,
  SET_POPUP_LOADER,
  CLOSE_POPUP,
} from "../Popup/ActionTypes";

const initialState = {
  dataguardHeaderData: null,
  locationSummary: null,
  heatmapData: null,
  totalAssetsCount: 0,
  keyDocOwnerData: [],
  rolesData: {},
  behaviorData: {},
  fromTimeStamp: null,
  toTimeStamp: null,
  headerLoader: false,
  locationSummaryLoader: false,
  heatmapLoader: false,
  keyDocOwnerLoader: false,
  rolesLoader: false,
  behaviorLoader: false,
  incognito: true,
  // Popup related state
  popupData: null,
  popupOpen: false,
  popupLoader: false,
  popupType: null,
  notificationUpdateStatus: false,
  revokeAccessUpdateStatus: false,
};

const DataguardReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_HEADER_LOADER': {
      return {
        ...state,
        headerLoader: action.payload,
      };
    }
    case 'SET_LOCATION_SUMMARY_LOADER': {
      return {
        ...state,
        locationSummaryLoader: action.payload,
      };
    }
    case 'SET_HEATMAP_LOADER': {
      return {
        ...state,
        heatmapLoader: action.payload,
      };
    }
    case 'SET_ROLES_LOADER': {
      return {
        ...state,
        rolesLoader: action.payload,
      };
    }
    case 'SET_BEHAVIOR_LOADER': {
      return {
        ...state,
        behaviorLoader: action.payload,
      };
    }
    case 'SET_KEY_DOC_OWNER_LOADER': {
      return {
        ...state,
        keyDocOwnerLoader: action.payload,
      };
    }
    case SET_LOCATION_SUMMARY: {
      return {
        ...state,
        locationSummary: action.payload,
      };
    }
    case SET_DATAGUARD_INCOGNITO: {
          return {
            ...state,
            incognito: action.payload
          }
        }
    case SET_DATAGUARD_HEADER_DATA: {
      return {
        ...state,
        dataguardHeaderData: action.payload,
      };
    }
    case SET_DATAGUARD_HEATMAP_DATA: {
      return {
        ...state,
        heatmapData: action.payload.heatmapData,
        totalAssetsCount: action.payload.totalAssetsCount,
      };
    }
    case SET_DATAGUARD_ROLES_DATA: {
      return {
        ...state,
        rolesData: action.payload,
      };
    }
    case SET_DATAGUARD_BEHAVIOR_DATA: {
      return {
        ...state,
        behaviorData: action.payload,
      };
    }
    case SET_KEY_DOC_OWNER_DATA: {
      return {
        ...state,
        keyDocOwnerData: action.payload,
      };
    }
    case SET_DATAGUARD_FROM_TIME_STAMP: {
      return {
        ...state,
        fromTimeStamp: action.payload,
      };
    }
    case SET_DATAGUARD_TO_TIME_STAMP: {
      return {
        ...state,
        toTimeStamp: action.payload,
      };
    }
    case SET_POPUP_DATA: {
      return {
        ...state,
        popupData: action.payload.data,
      };
    }
    case SET_POPUP_OPEN: {
      return {
        ...state,
        popupOpen: action.payload.open,
        popupDetails: action.payload.popupDetails,
      };
    }
    case SET_POPUP_LOADER: {
      return {
        ...state,
        popupLoader: action.payload,
      };
    }
    case SET_NOTIFICATION_UPDATE_STATUS: {
      return {
        ...state,
        notificationUpdateStatus: action.payload,
      }
    }
    case SET_REVOKE_ACCESS_UPDATE_STATUS: {
      return {
        ...state,
        revokeAccessUpdateStatus: action.payload,
      }
    }
    case CLOSE_POPUP: {
      return {
        ...state,
        popupOpen: false,
        popupData: null,
        popupType: null,
        popupLoader: false,
      };
    }
    default:
      return state;
  }
};

export default DataguardReducer;